import { GetVariableNameArgs } from '../config';
export class VariableUtil {
    static getConvertedVariableName(variableStore, variable) {
        if (variable.variableVersion) {
            return variable.name;
        }
        else {
            return variableStore.getVariableName(new GetVariableNameArgs(variable.name, variable.groupName, variable.dataSourceCode));
        }
    }
}
